import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const pharmacyApiUrl = typeof window !== 'undefined' ? window.serverData.data.pharmacyApiUrl : ''; // window is undefined during pre-render

export const getPharmacyDashBoardData = (proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/RefillAndPickupCount` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.RefillAndPickupCount", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.RefillAndPickupCount.Failure", start, url, err); return Promise.reject(err); });
};

export const getDefaultPharmacyData = (storeNumber, proxyId, token) => {
    const storeNumberParam = storeNumber ? `?storeNumber=${storeNumber}` : '';
    const proxyIdParam = proxyId ? ((storeNumber ? '&' : '?') + `proxyId=${proxyId}`) : '';
    var url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/GetPharmacy${storeNumberParam}${proxyIdParam}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.GetPharmacy.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.GetPharmacy.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getReadyForPickup = (proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/ReadyForPickup` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch2(url, token).then(response => {
        const list = [];
        response.forEach(item => {
            const pharmacyName = item.Pharmacy.Name;
            item.ReadyForPickups.forEach(rx => {
                list.push({
                    pharmacyName, storeNumber: rx.StoreNumber, rxNumber: rx.RxNumber,
                    rxDrugName: rx.RxDrugName, patientPay: rx.PatientPay
                });
            });
        });
        logAPI("MBHWeb.Api.Rx.ReadyForPickup.Get", start, url);
        return list;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.ReadyForPickup.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getReadyForRefill = (proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/ReadyForRefill` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch2(url, token).then(response => {
        const list = [];
        response.forEach(item => {
            const pharmacyName = item.Pharmacy.Name;
            item.ReadyForRefills.forEach(rx => {
                list.push({
                    pharmacyName, storeNumber: rx.StoreNumber, rxNumber: rx.RxNumber,
                    rxDrugName: rx.RxDrugName, refills: rx.Refills
                });
            });
        });
        logAPI("MBHWeb.Api.Rx.ReadyForRefill.Get", start, url);
        return list;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.ReadyForRefill.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getClosestPharmacy = (latitude, longitude, token) => {
    const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/GetClosestPharmacy?latitude=${latitude}&longitude=${longitude}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.GetClosestPharmacy", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.GetClosestPharmacy.Failure", start, url, err); return Promise.reject(err); });
};

export const submitExternalRxTransfer = (data, token, proxyId) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/TransferNonBaylorPrescription` + (proxyId ? `?proxyId=${proxyId}` : ''));
    var start = new Date();
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.Transfer.NonBSWPrescription", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Transfer.NonBSWPrescription.Failure", start, url, err); return Promise.reject(err); });
};

export const getPharmacyList = (data, proxyId, token) => {
    // const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/GetPharmacyList?city=${city}&zip=${zip}&latitude=${latitude}&longitude=${longitude}&radius=25`);
    const params = urlParams(
        'city', data.city, 'zip', data.zip, 'latitude', data.latitude, 'longitude', data.longitude, 'proxyId', proxyId
    );
    const url = encodeURI(`${pharmacyApiUrl}Api/MyBswHealth/GetPharmacyList${params}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.GetPharmacyList.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.GetPharmacyList.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getCities = (token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/Cities`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.Pharmacy.Cities.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Pharmacy.Cities.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getRecentlyUsedPharmacies = (token, proxyId) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/RecentlyUsedPharmacies` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.RecentlyUsedPharmacies", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.RecentlyUsedPharmacies.Failure", start, url, err); return Promise.reject(err); });
};

export const getActivePrescriptionList = (proxyId, token) => {
    const param = proxyId ? '?proxyId=' + proxyId : ''; 
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/PrescriptionList${param}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.PrescriptionList.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.PrescriptionList.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getRxDetail = (token, rxNumber, storeNumber, isExternalRx, proxyId) => {
    const params = `?rxNumber=${rxNumber}&storeNumber=${storeNumber}&isExternalRx=${isExternalRx}` + (proxyId ? `&proxyId=${proxyId}` : '');
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/PrescriptionDetails${params}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.PrescriptionDetail.Get", start, url);
        return response;
    }).catch(error => {
        console.log('getRxDetail api error', error);
        throw error;
        }).catch(err => { logAPI("MBHWeb.Api.Rx.PrescriptionDetail.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getRxHistory = (token, rxNumber, storeNumber, proxyId) => {
    const params = `?rxNumber=${rxNumber}&storeNumber=${storeNumber}` + (proxyId ? `&proxyId=${proxyId}` : '');
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/PrescriptionHistory${params}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.PrescriptionHistory.Get", start, url);
        return response;
    }).catch(error => {
        console.log('getRxHistory api error', error);
        throw error;
        }).catch(err => { logAPI("MBHWeb.Api.Rx.PrescriptionHistory.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const archivePrescription = (rxNumber, storeNumber, archive, proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/ArchivePrescription?rxNumber=${rxNumber}&storeNumber=${storeNumber}&isArchived=${archive}` + (proxyId ? `&proxyId=${proxyId}` : ''));
    var start = new Date();
    return fetch2(url, token, "", 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.ArchivePrescription.Post", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.ArchivePrescription.Post.Failure", start, url, err); return Promise.reject(err); });
};

export const getArchivedPrescriptionList = (proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/ArchivedPrescriptionList` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.ArchivedPrescriptionList.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.ArchivedPrescriptionList.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const unlinkedRxTransfers = (proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/UnlinkedRxTransfers` + (proxyId ? `?proxyId=${proxyId}` : ''));
    const start = new Date();
    return fetch3(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.Transfer.GetUnlinked", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Transfer.GetUnlinked.Failure", start, url, err); return Promise.reject(err); });
};

export const getOrderRefills = (storeNumber, proxyId, token) => {
    const storeNumberParam = storeNumber ? `?storeNumber=${storeNumber}` : '';
    const proxyIdParam = proxyId ? ((storeNumber ? '&' : '?') + `proxyId=${proxyId}`) : '';
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/OrderRefills${storeNumberParam}${proxyIdParam}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.OrderRefill.Get", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.OrderRefill.Get.Failure", start, url, err); return Promise.reject(err); });
};

export const getPickupHours = (storeNumber, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/GetPickupHours?storeNumber=${storeNumber}`);
    const start = new Date();
    return fetch2(url, token).then(response => {
        logAPI("MBHWeb.Api.Rx.PickupDetails", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.PickupDetails.Failure", start, url, err); return Promise.reject(err); });
};

export const submitIVROrder = (data, proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/SubmitIVROrder` + (proxyId ? `?proxyId=${proxyId}` : ''));
    var start = new Date();
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.SubmitIVROrder", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.SubmitIVROrder.Failure", start, url, err); return Promise.reject(err); });
};

export const submitRxTransfer = (data, token, proxyId) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/TransferBaylorPrescription` + (proxyId ? `?proxyId=${proxyId}` : ''));
    var start = new Date();
    return fetch2(url, token, JSON.stringify(data), 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.Transfer.BSWPrescription", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Transfer.BSWPrescription.Failure", start, url, err); return Promise.reject(err); });
};

export const setFavouritePharmacy = (storeNumber, proxyId, token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/SetDefaultPharmacy?storeNumber=${storeNumber}` + (proxyId ? `&proxyId=${proxyId}` : ''));
    var start = new Date();
    return fetch2(url, token, "", 'post').then(response => {
        logAPI("MBHWeb.Api.Rx.SetDefaultPharmacy", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.SetDefaultPharmacy.Failure", start, url, err); return Promise.reject(err); });
};

export const archiveUnlinkedRxTransfers = (token) => {
    const url = encodeURI(`${pharmacyApiUrl}api/myBSWHealth/ArchiveUnlinkedRxTransfers`);
    var start = new Date();
    return fetch2(url, token, "", 'put').then(response => {
        logAPI("MBHWeb.Api.Rx.Transfer.ArchiveUnlinked", start, url);
        return response;
    }).catch(err => { logAPI("MBHWeb.Api.Rx.Transfer.ArchiveUnlinked.Failure", start, url, err); return Promise.reject(err); });
};